export const SEND_BASE_DATA = 'SEND_BASE_DATA';
export const DELETE_GATE_WAY = 'DELETE_GATE_WAY';
export const UPDATE_PLANT_DATA = 'UPDATE_PLANT_DATA';
export const UPDATE_BASE_DATA = 'UPDATE_BASE_DATA';
export const UPDATE_ACTIVE_TEST_TAG = 'UPDATE_ACTIVE_TEST_TAG';
export const TOGGLE_BASE_DATA_FORM = 'TOGGLE_BASE_DATA_FORM';
export const READY_FOR_TEST = 'READY_FOR_TEST';
export const TOGGLE_SET_BASE_DATA_LOADING = 'TOGGLE_SET_BASE_DATA_LOADING';
export const UPDATE_TEST_RESULT = 'UPDATE_TEST_RESULT';
